import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Label, Row } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { loadCompanyInfo, saveCompanyInfo } from '../../../../../actions';
import { localizeCountryNames } from '../../../../../utils/CommonUtils';
import { countryList } from '../../../../../utils/Constants';
import { AvFeedback, AvField, AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";

class CompanyInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            primaryEmail: '',
            secondaryEmail: '',
            taxId: '',
            taxPercent: null,
            street: '',
            streetNumber: null,
            city: '',
            country: '',
            zipCode: '',
            taxValid: false
        };
    }

    componentDidMount() {
        const restaurantId = this.props.match.params.id;

        this.props.loadCompanyInfo(restaurantId)
    }

    componentDidUpdate(prevProps) {
        const { companyInfo } = this.props.restaurant;
        
        if(companyInfo !== prevProps.restaurant.companyInfo) {
            
            this.setState({
                name: companyInfo.name ? companyInfo.name : '',
                primaryEmail: companyInfo.primaryEmail ? companyInfo.primaryEmail : '',
                secondaryEmail: companyInfo.secondaryEmail ? companyInfo.secondaryEmail : '',
                taxId: companyInfo.taxId ? companyInfo.taxId : '',
                taxPercent: companyInfo.taxPercent || companyInfo.taxPercent === 0 ? companyInfo.taxPercent : null,
                street: companyInfo.address ? companyInfo.address.street : '',
                streetNumber: companyInfo.address ? companyInfo.address.streetNumber : null,
                city: companyInfo.address ? companyInfo.address.city : '',
                country: companyInfo.address ? companyInfo.address.country : '',
                zipCode: companyInfo.address ? companyInfo.address.zipCode : '',
                taxValid: companyInfo.taxValid
            })
        }
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    changeState = ({ target }) => {
        if(target.name === 'taxValid') {
            this.setState({
                ...this.state,
                taxValid: !this.state.taxValid
            });
        } else {
            this.setState({
                ...this.state,
                [target.name]: target.value
            });
        }
    }

    saveCompanyInfo(state, restaurantId) {

        this.props.saveCompanyInfo(state, restaurantId, () => {
            this.props.loadCompanyInfo(restaurantId)
        })
    }

    renderCountryOptions() {

        return countryList.map((country, i) => {
            return <option key={i} value={country}>{localizeCountryNames(country)}</option>
        });
    }

    renderName() {
        const { name } = this.state

        return (
            <AvGroup xs={8} style={{ display: 'flex', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.name')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="name"
                        placeholder={name}
                        value={name}
                        onChange={this.changeState}
                        required
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderPrimaryEmail() {
        const { primaryEmail } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.primaryEmail')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="email" 
                        name="primaryEmail"
                        placeholder={primaryEmail}
                        value={primaryEmail}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderSecondaryEmail() {
        const { secondaryEmail } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.secondaryEmail')}</Label>
                <AvInput
                    type="email" 
                    name="secondaryEmail"
                    placeholder={secondaryEmail}
                    value={secondaryEmail}
                    onChange={this.changeState}
                    disabled={this.props.isMenuuAdmin}
                />
            </AvGroup>
        )
    }

    renderTaxId() {
        const { taxId } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.vatNo')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="taxId"
                        placeholder={taxId}
                        value={taxId}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderTaxPercent() {
        const { taxPercent } = this.state;
        
        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.taxPercent')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="number" 
                        name="taxPercent"
                        placeholder={taxPercent ? taxPercent : ''}
                        value={taxPercent === 0 || taxPercent ? taxPercent : ''}
                        onChange={this.changeState}
                        required={true}
                        onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderStreet() {
        const { street } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.street')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="street"
                        placeholder={street}
                        value={street}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderStreetNumber() {
        const { streetNumber } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.streetNumber')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="number" 
                        name="streetNumber"
                        placeholder={streetNumber}
                        value={streetNumber}
                        onChange={this.changeState}
                        required={true}
                        onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderCity() {
        const { city } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.city')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="text" 
                        name="city"
                        placeholder={city}
                        value={city}
                        onChange={this.changeState}
                        required={true}
                        disabled={this.props.isMenuuAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        )
    }

    renderRestaurantCountry() {
        const { country } = this.state;
        
        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3} for="country" >{i18n.t('screens:restaurantsScreen.country')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvField type="select" name="country" id="country" placeholder={i18n.t('screens:restaurantsScreen.country')}
                        value={country}
                        onChange={this.changeState}
                        errorMessage={i18n.t('common:validations.chooseCountry')}
                        required
                        disabled={this.props.isMenuuAdmin}
                    >
                        <option value="">{i18n.t('common:validations.chooseCountry')}</option>
                        {this.renderCountryOptions()}
                    </AvField>
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </div>
            </AvGroup>
        );
    }

    renderZipCode() {
        const { zipCode } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.zipCode')}</Label>
                <AvInput
                    type="text" 
                    name="zipCode"
                    placeholder={zipCode}
                    value={zipCode}
                    onChange={this.changeState}
                    disabled={this.props.isMenuuAdmin}
                />
            </AvGroup>
        )
    }

    renderTaxValid() {
        const { taxValid } = this.state;

        return (
            <AvGroup xs={8} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={3}>{i18n.t('screens:paymentScreen.taxValid')}</Label>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                    <AvInput
                        type="checkbox" 
                        name="taxValid"
                        checked={taxValid}
                        onChange={this.changeState}
                        style={{marginLeft: '2px', marginTop: '12px'}}
                        disabled={this.props.isMenuuAdmin}
                    />
                </div>
            </AvGroup>
        )
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = this.props.styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.companyInfo')}</span>
            </div>
        );
    }

    renderBody() {
        const { saveBtn } = this.props.styles;
        const restaurantId = this.props.match.params.id;

        return (
            <Row xs={12}>
                <AvForm style={{ padding: '0px 0px 5px 0px', width: '100%'}} onValidSubmit={() => this.saveCompanyInfo(this.state, restaurantId)}>
                    <Col xs={8} style={{margin: '20px 30px'}}>
                        {this.renderName()}
                        {this.renderPrimaryEmail()}
                        {this.renderSecondaryEmail()}
                        {this.renderTaxId()}
                        {this.renderTaxPercent()}
                        {this.renderTaxValid()}
                        {this.renderStreet()}
                        {this.renderStreetNumber()}
                        {this.renderCity()}
                        {this.renderRestaurantCountry()}
                        {this.renderZipCode()}
                    </Col>
                    <Col xs={12} style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                        <Button disabled={this.props.isMenuuAdmin} color="primary" style={{ display: 'flex', alignItems: 'center' }}>
                            <span className="saveIcon" style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="save" color="#fff" size={18} /></span>
                            <span style={saveBtn}>{i18n.t('common:buttons.save')}</span>
                        </Button>
                    </Col>
                </AvForm>
            </Row>
        )
    }

    render() {
        
        return (
            <div>
                {this.renderHeader()}
                {this.renderBody()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        restaurant: state.restaurant
    }
}

export default connect(mapStateToProps, {loadCompanyInfo, saveCompanyInfo})(CompanyInfo);

const styles = {

    cardContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px'
    },
    btnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/CompanyInfo.js